import { useQpmMonitorRenameMutation } from "@/services/backend/qpm/monitors/api/monitor-api";
import { Label } from "@/shared/components/ui/label";
import { Input } from "@/shared/components/ui/input";
import t from "@/lang/lang";
import { useEffect, useState } from "react";

export function MonitorNameComponent({
  monitorId,
  value,
  disabled,
}: {
  monitorId: string;
  value: string;
  disabled?: boolean;
}) {
  const [rename] = useQpmMonitorRenameMutation();
  const [name, setName] = useState(value);

  useEffect(() => {
    setName(value);
  }, [value, monitorId]);

  return (
    <div className="grid grid-cols-4 items-center gap-1.5">
      <Label className="col-span-2" htmlFor="name">
        {t("Name")}
      </Label>
      <Input
        className="col-span-2"
        id="name"
        type="text"
        value={name}
        disabled={disabled}
        onChange={(e) => {
          if (disabled) return;
          setName(e.target.value);
        }}
        onBlur={() => {
          if (disabled) return;
          rename({ id: monitorId, name });
        }}
      />
    </div>
  );
}
